import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle, Activity, Coffee, Moon } from 'lucide-react';
export function FailedApproaches() {
  const approaches = [{
    icon: <XCircle className="w-8 h-8 text-red-400" data-id="element-31" />,
    text: 'Las dietas hipocalóricas estresan tus glándulas suprarrenales, bloqueando la quema de grasa.'
  }, {
    icon: <Activity className="w-8 h-8 text-red-400" data-id="element-32" />,
    text: 'El cardio intenso eleva el cortisol, enviando la señal de "almacenar grasa abdominal" de inmediato.'
  }, {
    icon: <Coffee className="w-8 h-8 text-red-400" data-id="element-33" />,
    text: 'Los desayunos basados en carbohidratos (jugos o pan) crean picos de insulina que garantizan fatiga a las 11 AM.'
  }, {
    icon: <Moon className="w-8 h-8 text-red-400" data-id="element-34" />,
    text: 'Ignorar la higiene térmica del sueño destruye tu capacidad de recuperación hormonal nocturna.'
  }];
  return <section className="py-20 bg-cream" data-id="element-35">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-36">
        <FadeIn data-id="element-37">
          <div className="text-center mb-16" data-id="element-38">
            <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-39">
              Por qué lo que has intentado no funcionó
            </h2>
            <p className="text-lg text-forest/70 max-w-2xl mx-auto" data-id="element-40">
              Las reglas han cambiado. Lo que te funcionaba a los 20 o 30 años
              ahora es contraproducente para tu química actual.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-41">
          {approaches.map((approach, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-42">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-sage-light flex gap-6 items-start h-full hover:shadow-md transition-shadow" data-id="element-43">
                <div className="flex-shrink-0 mt-1 bg-red-50 p-3 rounded-full" data-id="element-44">
                  {approach.icon}
                </div>
                <p className="text-forest/80 text-lg leading-relaxed" data-id="element-45">
                  {approach.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}